import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_InitialAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_InitialAssessment' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'>
                    <center> <h2>Initial Assessment</h2></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Informant:</span> </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbIndividualReceiving' name='cbIndividualReceiving' className='add-only' value='Individual Receiving' /> Individual Receiving Services <br />
                    <input type='checkbox' id='cbIndividualOther' name='cbIndividualOther' className='add-only' value='Other' /> Other: Relationship to Individual
                </p>
                <p className='w-375'> <input type='text' id='txtRelationshipToIndividual' name='txtRelationshipToIndividual' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Does the person seeking services have an Outpatient Commitment Order?</span> </p>
                <p className='w-750'>
                    <input type='radio' id='rbCommitment_Yes' name='rbCommitment' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCommitment_No' name='rbCommitment' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does the person seeking services meet the DMH "Codependent" status?</span>
                    <span className='small'>(seeking services based on the mental health or substance use, behavioral problems, of another person, and it is affecting them negatively)</span> </p>
                <p className='w-750'>
                    <input type='radio' id='rbCodependent_Yes' name='rbCodependent' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCodependent_No' name='rbCodependent' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <center> <h2>GUARDIANSHIP INFORMATION</h2></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name Of Guardian / Custodian:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Guardianship Documentation Verified:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameOfGuardian' name='txtNameOfGuardian' className='add-only' /> </td>
                        <td className='w-375'>
                            <input type='radio' id='rbGuardianship_Yes' name='rbGuardianship' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbGuardianship_No' name='rbGuardianship' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> Guardian / Custodian Address:</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Guardian / Custodian Phone Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtCustodianAddress' name='txtCustodianAddress' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCustodianPhoneNumber' name='txtCustodianPhoneNumber' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Is the family involved with the Department of Human Services?</span>
                    <input type='radio' id='rbHumanServices_Yes' name='rbHumanServices' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHumanServices_No' name='rbHumanServices' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'>If yes, has a consent to release information been obtained?</span>
                    <input type='radio' id='rbReleaseInformation_Yes' name='rbReleaseInformation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReleaseInformation_No' name='rbReleaseInformation' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, please explain and indicate the name of the assigned case worker.</span>
                    <input type='text' id='txtAssignedCaseWorker' name='txtAssignedCaseWorker' className='add-only' />
                </p>

                <p className='w-750'> <center> <h2>CONFIDENTIALITY</h2></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Were the limits of confidentiality reviewed with Individual and/or Guardian?</span>
                    <input type='radio' id='rbGuardian_Yes' name='rbGuardian' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbGuardian_No' name='rbGuardian' className='add-only' value='No' /> No
                </p>
                <p className='w-750'> <span className='eleHeader'>If NO, please explain.</span>
                    <input type='text' id='txtIfNoPleaseExplain' name='txtIfNoPleaseExplain' className='add-only' />
                </p>

                <p className='w-750'> <center> <h2>DESCRIPTION OF NEED</h2></center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>What is your reason for seeking services today? What specific needs do you currently have?</span>
                    <span className='small'>(Include a description/perception of difficulties according to the individual seeking services and any applicable family members/legal guardian.)</span>
                    <textarea id='txtSpecificNeeds' name='txtSpecificNeeds' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Is the reason for seeking services today related to substance use?</span>
                    <input type='radio' id='rbSubstanceUse_Yes' name='rbSubstanceUse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSubstanceUse_No' name='rbSubstanceUse' className='add-only' value='No' /> No <br />
                    <span className='small'>If yes, the Substance Use Disorder Level of Care Placement Assessment must also be completed.</span>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>What previous coping skills have been helpful in the past?</span>
                    <textarea id='txtCopingSkills' name='txtCopingSkills' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Is the reason for seeking services today related to substance use?</span>
                    <input type='radio' id='rbSubstanceUsereason_Yes' name='rbSubstanceUsereason' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSubstanceUsereason_No' name='rbSubstanceUsereason' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>(If yes, explain)</span>
                    <input type='text' id='txtIfYesreason' name='txtIfYesreason' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Attempts of Suicide:</span>
                    <input type='radio' id='rbAttemptsOfSuicide_Yes' name='rbAttemptsOfSuicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAttemptsOfSuicide_No' name='rbAttemptsOfSuicide' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>(If yes, explain)</span>
                    <input type='text' id='txtIfYesExplain' name='txtIfYesExplain' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Thoughts of Homicide:</span>
                    <input type='radio' id='rbHomicide_Yes' name='rbHomicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHomicide_No' name='rbHomicide' className='add-only' value='No' /> No (Indicate the need for "duty to warn") <br />
                    <span className='eleHeader'>(If yes, explain)</span>
                    <input type='text' id='txtHomicideIfYesExplain' name='txtHomicideIfYesExplain' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Acts of Self-Harm:</span>
                    <input type='radio' id='rbSelfHarm_Yes' name='rbSelfHarm' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSelfHarm_No' name='rbSelfHarm' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>(If yes, explain)</span>
                    <input type='text' id='txtSelfHarmIfYesExplain' name='txtSelfHarmIfYesExplain' className='add-only' />
                </p>

                <p className='w-750'> <center> <h2>SOCIAL / CULTURAL</h2></center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Identification of Support Systems:</span>
                    <span className='small'>(Address family relationships, interpersonal relationships, and community support systems)</span>
                    <textarea id='txtIdentification' name='txtIdentification' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Meaningful Activities, Cultural / Ethnic / Spiritual interests, Supports:</span>
                    <span className='small'>(Address hobbies, leisure activities, etc.)</span>
                    <textarea id='txtMeaningfulActivities' name='txtMeaningfulActivities' className='add-only'></textarea>
                </p>

                <p className='w-750'> <center> <h2>Living Situation</h2></center>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is your current living arrangement (strengths and concerns)? Who lives with you? What are your views on your current arrangement?</span>
                    <textarea id='txtStrengthsAndConcerns' name='txtStrengthsAndConcerns' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Does the individual meet the DMH "Parenting" Classification? </span>
                    <input type='radio' id='rbParenting_Yes' name='rbParenting' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbParenting_No' name='rbParenting' className='add-only' value='No' /> No <br />
                    <span className='small'>(Parenting Classification - Mother or Father of dependent(s) under the age of five; and their dependent(s) will be accompanying them in the agency's Residential Treatment program during the current treatment experience.)</span>
                    <span className='eleHeader'>(If yes, explain)</span>
                    <input type='text' id='txtParentingClassification' name='txtParentingClassification' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Needs Related to Living Situation
                    </span>
                    <span className='small'>(money management, benefits, living arrangements, clothing, personal care, child care, rent, other)</span>
                    <textarea id='txtMoneyManagement' name='txtMoneyManagement' className='add-only'></textarea>
                </p>

                <p className='w-750'><center> <h2>Developmental History <br /><small>
                    (Complete only for Children & Youth up to age 21 and everyone with ID/DD)</small></h2></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>During pregnancy, did mother use alcohol or other drugs? </span>
                    <input type='radio' id='rbDuringPregnancy_Yes' name='rbDuringPregnancy' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDuringPregnancy_No' name='rbDuringPregnancy' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe any problems with the pregnancy or birth:
                    </span>
                    <input type='text' id='txtBirth' name='txtBirth' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Were there any developmental issues? </span>
                    <input type='radio' id='rbDevelopmentalIssues_Yes' name='rbDevelopmentalIssues' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDevelopmentalIssues_No' name='rbDevelopmentalIssues' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>(If yes, explain)</span>
                    <input type='text' id='txtDevelopmentalIfYes' name='txtDevelopmentalIfYes' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe any childhood accidents or injuries:
                    </span>
                    <input type='text' id='txtChildhoodAccidents' name='txtChildhoodAccidents' className='add-only' />
                </p>

                <p className='w-750'><center> <h2>Education<br /><small>
                    (Complete for Children & Youth up to age 21 and Adults)</small></h2></center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Select the individual's current or highest level of education completed:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='None' /> None, never attended grade school </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='Kindergarten' /> Kindergarten </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='1st Grade' /> 1<sup>st</sup> Grade
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='2nd Grade' /> 2<sup>nd</sup> Grade </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='3rd Grade' /> 3<sup>rd</sup> Grade </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='4th Grade' /> 4<sup>th</sup> Grade
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='5th Grade' /> 5<sup>th</sup> Grade </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='6th Grade' /> 6<sup>th</sup> Grade </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='1st Grade' /> 7<sup>th</sup> Grade
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='8th Grade' /> 8<sup>th</sup> Grade
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='9th Grade' /> 9<sup>th</sup> Grade </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='10th Grade' /> 10<sup>th</sup> Grade
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='11th Grade' /> 11<sup>th</sup> Grade </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='12th Grade' /> 12<sup>th</sup> Grade </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='High School Graduate or GED' /> High School Graduate or GED
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='1-year of College' /> 1-year of College </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='2-years' /> 2-years of College or Associates Degree </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='3-years of College' /> 3-years of College
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='Bachelors degree' /> Bachelor's degree </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbKindergarten' name='cbKindergarten' className='add-only' value='Some Post Graduate Study' /> Some Post Graduate Study
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='Masters degree' /> Master's degree
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCurrentMood_3' name='cbCurrentMood_3' className='add-only' value='Technical Trade School' /> Technical Trade School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='Graduate or Professional School' /> Graduate or Professional School (Doctoral Study, Med School, Law School, etc.) </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Name of school: </span>
                    <input type='text' id='txtNameOfSchool' name='txtNameOfSchool' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Does child/yout Special Education Services? </span>
                    <input type='radio' id='rbSpecialEducation_Yes' name='rbSpecialEducation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSpecialEducation_No' name='rbSpecialEducation' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>(If yes, complete release of information to obtain a copy of the current Individualized Education Plan (IEP))</span>
                    <input type='text' id='txtSpecialEducationIfYes' name='txtSpecialEducationIfYes' className='add-only' />
                </p>

                <p className='w-750'><center> <h2>Additional Information<small>
                    (Children & Youth up to age 21)</small></h2></center>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Educational Issues/ Needs</span>
                    <span className='small'>(grades, attendance, suspensions, expulsions)</span>
                    <textarea id='txtEducationalIssues' name='txtEducationalIssues' className='add-only'></textarea>
                </p>

                <p className='w-750'><center> <h2>Employment<small>
                    (adults only)</small></h2></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Are you employed? </span>
                    <input type='radio' id='rbAreYouEmployed_Yes' name='rbAreYouEmployed' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAreYouEmployed_No' name='rbAreYouEmployed' className='add-only' value='No' /> No
                    <br />
                    <span className='eleHeader'>If no, do you want to be employed?</span>
                    <input type='text' id='txtWantToBeEmployed' name='txtWantToBeEmployed' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Employment Barriers/ Related Needs? </span>
                    <input type='text' id='txtEmploymentBarriers' name='txtEmploymentBarriers' className='add-only' />
                </p>

                <p className='w-750'><center> <h2>Current Legal Status</h2></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has the individual ever been incarcerated, in a juvenile detention, jail, or prison?
                </span>
                    <input type='radio' id='rbIncarcerated_Yes' name='rbIncarcerated' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIncarcerated_No' name='rbIncarcerated' className='add-only' value='No' /> No
                    <br />
                    <span className='eleHeader'>If yes, when?</span>
                    <input type='text' id='txtIfYesWhen' name='txtIfYesWhen' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Has the individual been involved with the legal system? </span>
                    <input type='radio' id='rbLegalSystem_Yes' name='rbLegalSystem' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLegalSystem_No' name='rbLegalSystem' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'>Any involvement within the past twelve months? </span>
                    <input type='radio' id='rbTwelveMonths_Yes' name='rbTwelveMonths' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTwelveMonths_No' name='rbTwelveMonths' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'>Arrests:
                </span>
                    <input type='radio' id='rbArrests_Yes' name='rbArrests' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbArrests_No' name='rbArrests' className='add-only' value='No' /> No
                    <br />
                    <span className='eleHeader'>If yes, indicate type and number of arrest(s): </span>
                    <input type='text' id='txtNumberOfArrest' name='txtNumberOfArrest' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Number of arrests in the past 30 days: </span>
                    <input type='text' id='txtNumberOfArrestsInPast' name='txtNumberOfArrestsInPast' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Pending Charges: </span>
                    <input type='radio' id='rbPendingCharges_Yes' name='rbPendingCharges' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPendingCharges_No' name='rbPendingCharges' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>If yes, indicate type and number of pending charges: </span>
                    <input type='text' id='txtPendingCharges' name='txtPendingCharges' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Substance Use Related Legal Issues: </span>
                    <input type='text' id='txtRelatedLegalIssues' name='txtRelatedLegalIssues' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Is this person currently on parole and/or probation? </span>
                    <input type='radio' id='rbCurrentlyOnParole_Yes' name='rbCurrentlyOnParole' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentlyOnParole_No' name='rbCurrentlyOnParole' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>If applicable, indicate to whom reports should be submitted: </span>
                    <input type='text' id='txtIfApplicable' name='txtIfApplicable' className='add-only' />
                </p>

                <p className='w-750'><center> <h3>MEDICAL HISTORY</h3></center>
                </p>
                <p className='w-750'> <span className='eleHeader'>Appetite Issues: </span>
                    <input type='text' id='txtAppetiteIssues' name='txtAppetiteIssues' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Sleep Issues: </span>
                    <input type='text' id='txtSleepIssues' name='txtSleepIssues' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Current or Chronic Diseases </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBloodPressureDiseases' name='cbBloodPressureDiseases' className='add-only' value='high blood pressure' /> high blood pressure </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDiabetesDiseases' name='cbDiabetesDiseases' className='add-only' value='diabetes' /> diabetes </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThyroidDiseases' name='cbThyroidDiseases' className='add-only' value='thyroid' /> thyroid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOtherDiseases' name='cbOtherDiseases' className='add-only' value='Other' /> Other <br />
                            <input type='text' id='txtOtherDiseases' name='txtOtherDiseases' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Family History </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBloodPressureFamily' name='cbBloodPressureFamily' className='add-only' value='high blood pressure' /> high blood pressure </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDiabetesFamily' name='cbDiabetesFamily' className='add-only' value='diabetes' /> diabetes </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThyroidFamily' name='cbThyroidFamily' className='add-only' value='thyroid' /> thyroid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOtherFamily' name='cbOtherFamily' className='add-only' value='Other' /> Other <br />
                            <input type='text' id='txtOtherFamily' name='txtOtherFamily' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Additional Medical History or Health and Safety Issues: </span>
                    <input type='text' id='txtSafetyIssues' name='txtSafetyIssues' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Health-Related Needs: </span>
                    <input type='text' id='txtHealthRelatedNeeds' name='txtHealthRelatedNeeds' className='add-only' />
                </p>

                <p className='w-750'><center> <h3>INDIVIDUAL MENTAL HEALTH HISTORY</h3></center>
                </p>
                <p className='w-750'><center> <h5>Previous Assessment History</h5></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have psychological, educational or functional assessments been completed in the last twelve months? </span>
                    <input type='radio' id='rbPsychological_Yes' name='rbPsychological' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPsychological_No' name='rbPsychological' className='add-only' value='No' /> No <br />
                    <span className='small'> (if yes, complete release of information to obtain a copy of the applicable assessmant.) </span>
                    <span className='eleHeader'>If yes, indicate type of assessment </span>
                    <input type='text' id='txtTypeOfAssessment' name='txtTypeOfAssessment' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Previous or Current Diagnoses: </span>
                    <textarea id='txtCurrentDiagnoses' name='txtCurrentDiagnoses' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Mental Health Needs:</span>
                    <textarea id='txtMentalHealth' name='txtMentalHealth' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Family History of Psychiatric or Substance Use Disorder(s) </span>
                    <input type='radio' id='rbUseDisorder_Yes' name='rbUseDisorder' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbUseDisorder_No' name='rbUseDisorder' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>If yes, please describe. </span>
                    <input type='text' id='txtPleaseDescribe' name='txtPleaseDescribe' className='add-only' />
                </p>

                <p className='w-750'><center> <h3>Outpatient Behavioral Health Agency</h3></center>
                </p>
                <p className='w-375'>
                    <input type='checkbox' id='cbOutpatientNoneReported' name='cbOutpatientNoneReported' className='add-only' value='None Reported' /> None Reported
                </p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Treatment Agency</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Service Received</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of Service</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Has Consent to Release Information Been Requested?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtTreatmentAgency_1' name='txtTreatmentAgency_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtServiceReceived_1' name='txtServiceReceived_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfService_1' name='txtDateOfService_1' className='add-only' /> </td>
                        <td className='w-250'> <center>
                            <input type='radio' id='rbReleaseInformation_Yes1' name='rbReleaseInformation_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbrbReleaseInformation_No1' name='rbReleaseInformation_1' className='add-only' value='No' /> No </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtTreatmentAgency_2' name='txtTreatmentAgency_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtServiceReceived_2' name='txtServiceReceived_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfService_2' name='txtDateOfService_2' className='add-only' /> </td>
                        <td className='w-250'><center>
                            <input type='radio' id='rbReleaseInformation_Yes2' name='rbReleaseInformation_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbrbReleaseInformation_No2' name='rbReleaseInformation_2' className='add-only' value='No' /> No </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtTreatmentAgency_3' name='txtTreatmentAgency_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtServiceReceived_3' name='txtServiceReceived_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfService_3' name='txtDateOfService_3' className='add-only' /> </td>
                        <td className='w-250'><center>
                            <input type='radio' id='rbReleaseInformation_Yes3' name='rbReleaseInformation_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbrbReleaseInformation_No3' name='rbReleaseInformation_3' className='add-only' value='No' /> No </center>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h3>Psychiatric Hosoitalizations / Residential Treatment</h3></center>
                </p>
                <p className='w-375'>
                    <input type='checkbox' id='cbPsychiatricNoneReported' name='cbPsychiatricNoneReported' className='add-only' value='None Reported' /> None Reported
                </p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Treatments </span> </td>
                        <td className='w-150'> <span className='eleHeader'>Reason <small>(suicidal, depressed, etc.)</small></span></td>
                        <td className='w-150'> <span className='eleHeader'>Date of Service</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Has Consent to Release Information Been Requested?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtTreatments_1' name='txtTreatments_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtReason_1' name='txtReason_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfService_4' name='txtDateOfService_4' className='add-only' /> </td>
                        <td className='w-250'><center>
                            <input type='radio' id='rbReleaseInformation_Yes4' name='rbReleaseInformation_4' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbrbReleaseInformation_No4' name='rbReleaseInformation_4' className='add-only' value='No' /> No </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtTreatments_2' name='txtTreatments_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtReason_2' name='txtReason_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfService_5' name='txtDateOfService_5' className='add-only' /> </td>
                        <td className='w-250'><center>
                            <input type='radio' id='rbReleaseInformation_Yes5' name='rbReleaseInformation_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbrbReleaseInformation_No5' name='rbReleaseInformation_5' className='add-only' value='No' /> No </center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtTreatments_3' name='txtTreatments_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtReason_3' name='txtReason_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfService_6' name='txtDateOfService_6' className='add-only' /> </td>
                        <td className='w-250'><center>
                            <input type='radio' id='rbReleaseInformation_Yes6' name='rbReleaseInformation_6' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbrbReleaseInformation_No6' name='rbReleaseInformation_6' className='add-only' value='No' /> No </center>
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h3>Initial Observations</h3></center>
                </p>
                <p className='w-750'><b>General Observations</b></p>

                <p className='w-750'> <span className='eleHeader'> Appearance: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearanceAppropriate' name='cbAppearanceAppropriate' className='add-only' value='Appropriate' /> Appropriate </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearanceDisheveled' name='cbAppearanceDisheveled' className='add-only' value='Disheveled' /> Disheveled </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearanceUnclean' name='cbAppearanceUnclean' className='add-only' value='Unclean' /> Unclean
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAppearanceOther' name='cbAppearanceOther' className='add-only' value='Other' /> Other
                            <input type='text' id='txtAppearanceOther' name='txtAppearanceOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Speech: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpeechAppropriate' name='cbSpeechAppropriate' className='add-only' value='Appropriate' /> Appropriate </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpeechSlow' name='cbSpeechSlow' className='add-only' value='slow' /> slow </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbSpeechMechanical' name='cbSpeechMechanical' className='add-only' value='Mechanical' /> Mechanical
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeechRapid' name='cbSpeechRapid' className='add-only' value='Rapid' /> Rapid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSpeechOther' name='cbSpeechOther' className='add-only' value='Other' /> Other
                            <input type='text' id='txtSpeechOther' name='txtSpeechOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Affect: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffectAppropriate' name='cbAffectAppropriate' className='add-only' value='Appropriate' /> Appropriate </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffectFlat' name='cbAffectFlat' className='add-only' value='Flat' /> Flat </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffectLabile' name='cbAffectLabile' className='add-only' value='Labile' /> Labile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAffectOther' name='cbAffectOther' className='add-only' value='Other' /> Other
                            <input type='text' id='txtAffectOther' name='txtAffectOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Delusions: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbDelusionsNa' name='cbDelusionsNa' className='add-only' value='N/A' /> N/A <br />
                    <input type='checkbox' id='cbDelusionsDescription' name='cbDelusionsDescription' className='add-only' value='Description' /> Description:
                    <input type='text' id='txtDelusionsDescription' name='txtDelusionsDescription' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Hallucinations: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbHallucinationsNa' name='cbHallucinationsNa' className='add-only' value='N/A' /> N/A <br />
                    <input type='checkbox' id='cbHallucinationsDescription' name='cbHallucinationsDescription' className='add-only' value='Description' /> Description:
                    <input type='text' id='txtHallucinationsDescription' name='txtHallucinationsDescription' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Mood: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMoodAppropriate' name='cbMoodAppropriate' className='add-only' value='Appropriate' /> Appropriate </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMoodManic' name='cbMoodManic' className='add-only' value='Manic' /> Manic </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMoodDepressed' name='cbMoodDepressed' className='add-only' value='Depressed' /> Depressed
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMoodLabile' name='cbMoodLabile' className='add-only' value='Labile' /> Labile </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMoodIrritable' name='cbMoodIrritable' className='add-only' value='Irritable' /> Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMoodOther' name='cbMoodOther' className='add-only' value='Other' /> Other
                            <input type='text' id='txtMoodOther' name='txtMoodOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Orientation: </span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbOrientationPerson' name='cbOrientationPerson' className='add-only' value='Person' /> Person </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbOrientationPlace' name='cbOrientationPlace' className='add-only' value='Place' /> Place </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOrientationTime' name='cbOrientationTime' className='add-only' value='Time' /> Time
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbOrientationSituation' name='cbOrientationSituation' className='add-only' value='Situation' /> Situation </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOrientationOther' name='cbOrientationOther' className='add-only' value='Other' /> Other
                            <input type='text' id='txtOrientationOther' name='txtOrientationOther' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>Indication Of Functional Limitation(s):<small>(Check Major Life Areas Affected)</small></h4></center>
                </p>
                <p className='w-750'> <span className='eleHeader'> Basic living skills (eating, bathing, dressing, etc.) </span>
                    <textarea id='txtBasicLivingSkills' name='txtBasicLivingSkills' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'> Instrumental living skills (maintain a household, managing money, getting around the community, taking prescribed medications, etc.) </span>
                    <textarea id='txtInstrumentalLivingSkills' name='txtInstrumentalLivingSkills' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'> Social functioning (ability to function within the family, vocational or educational function, other social contexts, etc.) </span>
                    <textarea id='txtSocialFunctioning' name='txtSocialFunctioning' className='add-only'></textarea>
                </p>

                <p className='w-750'><center> <h4>SUMMARY / RECOMMENDATIONS</h4></center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Health: </span>
                    <input type='text' id='txtHealth' name='txtHealth' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Home:</span>
                    <input type='text' id='txtHome' name='txtHome' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Community:</span>
                    <input type='text' id='txtCommunity' name='txtCommunity' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Purpose:</span>
                    <input type='text' id='txtPurpose' name='txtPurpose' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Other:</span>
                    <input type='text' id='txtSummaryOther' name='txtSummaryOther' className='add-only' />
                </p>

                <p className='w-750'><center> <h4>INITIAL DIAGNOSTIC IMPRESSION</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Codes:</span> </td>
                        <td className='w-500'> <span className='eleHeader'>Description:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_1' name='txtCodes_1' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_1' name='txtDescription_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_2' name='txtCodes_2' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_2' name='txtDescription_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_3' name='txtCodes_3' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_3' name='txtDescription_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_4' name='txtCodes_4' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_4' name='txtDescription_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_5' name='txtCodes_5' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_5' name='txtDescription_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_6' name='txtCodes_6' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_6' name='txtDescription_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_7' name='txtCodes_7' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_7' name='txtDescription_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCodes_8' name='txtCodes_8' className='add-only' /> </td>
                        <td className='w-500'> <input type='text' id='txtDescription_8' name='txtDescription_8' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>SIGNATURES / CREDENTIALS</h4></center>
                </p>

                <p className='w-750'><center> <h4>Trauma History</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Name</span> </td>
                        <td className='w-200'> <span className='eleHeader'>ID Number</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Date</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtTraumaName' name='txtTraumaName' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtTraumaIdNumber' name='txtTraumaIdNumber' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtDate' name='txtDate' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Time In:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Time Out:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Total:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='time' id='txtTimeIn_2' name='txtTimeIn_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtTimeOut_2' name='txtTimeOut_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtTotal' name='txtTotal' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> The clinician and/or person are permitted to only answer questions that are appropriate or applicable.</span>
                    <input type='text' id='txtClinician' name='txtClinician' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Please indicate if any of the following have happened to you and how it may have affected you.</span>
                    <input type='text' id='txtPleaseIndicate' name='txtPleaseIndicate' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Do you have trauma concerns that you wish to address during this experience? </span>
                    <input type='radio' id='rbTraumaConcerns_Yes' name='rbTraumaConcerns' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTraumaConcerns_No' name='rbTraumaConcerns' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>If yes, please elaborate on those concerns. </span>
                    <input type='text' id='txtTraumaConcerns' name='txtTraumaConcerns' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever experienced any of the following? </span>
                    <input type='radio' id='rbExperienced_Yes' name='rbExperienced' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbExperienced_No' name='rbExperienced' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPhysicalAbuse' name='cbPhysicalAbuse' className='add-only' value='Physical Abuse' /> Physical Abuse </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEmotionalAbuse' name='cbEmotionalAbuse' className='add-only' value='Emotional Abuse' /> Emotional Abuse </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualAbuse' name='cbSexualAbuse' className='add-only' value='Sexual Abuse' /> Sexual Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeglect' name='cbNeglect' className='add-only' value='Neglect' /> Neglect </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDomesticViolence' name='cbDomesticViolence' className='add-only' value='Domestic Violence' /> Domestic Violence </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMilitaryService' name='cbMilitaryService' className='add-only' value='Military Service' /> Military Service
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNaturalDisaster' name='cbNaturalDisaster' className='add-only' value='Natural Disaster' /> Natural Disaster
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other <br />
                            <input type='text' id='txtNaturalOther' name='txtNaturalOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>If yes, when, by whom (if applicable), and what has been the effect on you? </span>
                    <input type='text' id='txtTraumaConcerns' name='txtTraumaConcerns' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever done any of the following to someone? </span>
                    <input type='radio' id='rbFollowing_Yes' name='rbFollowing' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFollowing_No' name='rbFollowing' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPhysicalAbuse' name='cbPhysicalAbuse' className='add-only' value='Physical Abuse' /> Physical Abuse </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEmotionalAbuse' name='cbEmotionalAbuse' className='add-only' value='Emotional Abuse' /> Emotional Abuse </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualAbuse' name='cbSexualAbuse' className='add-only' value='Sexual Abuse' /> Sexual Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeglect' name='cbNeglect' className='add-only' value='Neglect' /> Neglect </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDomesticViolence' name='cbDomesticViolence' className='add-only' value='Domestic Violence' /> Domestic Violence </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDomesticOther' name='cbDomesticOther' className='add-only' value='Other' /> Other <br />
                            <input type='text' id='txtDomesticOther' name='txtDomesticOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If yes, when, to whom (if applicable), and what has been the effect on you? </span>
                    <input type='text' id='txtTraumaConcerns' name='txtTraumaConcerns' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Did you ever receive counseling for any of the above </span>
                    <input type='radio' id='rbCounseling_Yes' name='rbCounseling' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCounseling_No' name='rbCounseling' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>If so, when, and where? </span>
                    <input type='text' id='txtCounselingWhere' name='txtCounselingWhere' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever served in the military, law enforcement or as a first responder? </span>
                    <input type='radio' id='rbMilitary_Yes' name='rbMilitary' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMilitary_No' name='rbMilitary' className='add-only' value='No' /> No <br />
                    <span className='eleHeader'>If yes, indicate the capacity in which you served. </span>
                    <textarea id='txtMilitaryIfYes' name='txtMilitaryIfYes' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever seen or been in a really bad accident? </span>
                    <textarea id='txtReallyBadAccident' name='txtReallyBadAccident' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has someone close to you ever been so badly injured or sick that s/he almost died? </span>
                    <textarea id='txtBadlyInjured' name='txtBadlyInjured' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has someone close to you ever died? </span>
                    <textarea id='txtEverDied' name='txtEverDied' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever been so sick that you or the doctor thought you might die? </span>
                    <textarea id='txtDoctorThought' name='txtDoctorThought' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever been unexpectedly separated from someone who you depend on for love or security for more than a few days? </span>
                    <textarea id='txtUnexpectedly' name='txtUnexpectedly' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has someone close to you ever tried to kill or hurt him/herself? </span>
                    <textarea id='txtTriedToKill' name='txtTriedToKill' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has someone ever physically hurt you or threatened to hurt you? </span>
                    <textarea id='txtPhysicallyHurt' name='txtPhysicallyHurt' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever been mugged or seen someone you care about get mugged? </span>
                    <textarea id='txtMugged' name='txtMugged' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has anyone ever kidnapped you? </span>
                    <textarea id='txtKidnapped' name='txtKidnapped' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever been attacked by a dog or other animal? </span>
                    <textarea id='txtAttacked' name='txtAttacked' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever seen or heard people physically fighting or threatening to hurt each other? (In or outside of the family)? </span>
                    <textarea id='txtThreatening' name='txtThreatening' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever witnessed a family member who was arrested or in jail? </span>
                    <textarea id='txtArrested' name='txtArrested' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever had a time in your life when you did not have a place to live or enough food? </span>
                    <textarea id='txtEnoughFood' name='txtEnoughFood' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Has someone ever made you see or do something sexual? Or have you seen or heard someone else being forced to do sex acts? </span>
                    <textarea id='txtSexual' name='txtSexual' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Have you ever watched people using drugs, like smoking drugs or using needles? </span>
                    <textarea id='txtUsingNeedles' name='txtUsingNeedles' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-450'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-450'> Staff Signature/Credential </td>
                        <td className='small w-300'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>Individual Service Plan</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name</span> </td>
                        <td className='w-375'> <span className='eleHeader'>ID Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtIndividualName' name='txtIndividualName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtIndividualIdNumber' name='txtIndividualIdNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Asmission Date:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Date of Plan Implementation</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtAsmissionDate' name='txtAsmissionDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtPlanImplementation' name='txtPlanImplementation' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNew' name='cbNew' className='add-only' value='New' /> New </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReWrite' name='cbReWrite' className='add-only' value='Re-Write' /> Re-Write </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddendum' name='cbAddendum' className='add-only' value='Addendum' /> Addendum
                        </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>Community Support has been offered to me and I choose:</h4></center>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbParticipate' name='cbParticipate' className='add-only' value='YES' /> <b>YES,</b>I do want to participate &nbsp;
                    <input type='text' id='txtInitials' name='txtInitials' className='add-only w-200 custom-add-only' />
                    (initials of individual receiving services)<b>[see Recovery Support Plan]</b>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbDoNotWant' name='cbDoNotWant' className='add-only' value='NO' /> <b>NO,</b>I do NOT want to participate &nbsp;
                    <input type='text' id='txtSeeRecovery' name='txtSeeRecovery' className='add-only w-200 custom-add-only' />
                    (initials of individual receiving services)<b>[see Recovery Support Plan]</b>

                </p>

                <p className='w-750'> <span className='eleHeader'>LONG TERM GOALS (include hopes/dreams/goals) </span>
                    <textarea id='txtLongTermGoals' name='txtLongTermGoals' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>SHORT TERM GOALS </span>
                    <textarea id='txtShortTermGoals' name='txtShortTermGoals' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>INDIVIDUAL'S STRENGTHS </span>
                    <textarea id='txtIndividualStrengths' name='txtIndividualStrengths' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>IDENTIFIED BARRIERS (Based on Functional Assessment) </span>
                    <textarea id='txtIdentifiedBarriers' name='txtIdentifiedBarriers' className='add-only'></textarea>
                </p>

                <p className='w-750'><center> <h4>INDIVIDUAL'S AREAS OF NEED</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>Area of needed support/observable behaviors/symptoms:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Duration:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtObservable' name='txtObservable' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDuration' name='txtDuration' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <span className='eleHeader'>How do needs/behaviors/symptoms create functional limitations for the individual?</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Frequency:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-600'> <input type='text' id='txtSymptoms' name='txtSymptoms' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtFrequency' name='txtFrequency' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>INDIVIDUALIZED PLAN FOR SERVICES</h4></center>
                </p>

                <p className='w-750'> <b>Objective #1: </b></p>

                <table>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Interventions</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Service Area Assigned:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Criteria/Outcomes for Completion</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Initiation Date:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Target Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtInterventions_1' name='txtInterventions_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtServiceArea_1' name='txtServiceArea_1' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtCriteria_1' name='txtCriteria_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtInitiationDate_1' name='txtInitiationDate_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_1' name='txtTargetDate_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b>Objective #2: </b></p>

                <table>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Interventions</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Service Area Assigned:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Criteria/Outcomes for Completion</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Initiation Date:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Target Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtInterventions_2' name='txtInterventions_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtServiceArea_2' name='txtServiceArea_2' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtCriteria_2' name='txtCriteria_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtInitiationDate_2' name='txtInitiationDate_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_2' name='txtTargetDate_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b>Objective #3: </b></p>

                <table>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Interventions</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Service Area Assigned:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Criteria/Outcomes for Completion</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Initiation Date:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Target Date:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtInterventions_3' name='txtInterventions_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtServiceArea_3' name='txtServiceArea_3' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtCriteria_3' name='txtCriteria_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtInitiationDate_3' name='txtInitiationDate_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtTargetDate_3' name='txtTargetDate_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Service Area(s) Assigned: </span>
                    <textarea id='txtAssigned' name='txtAssigned' className='add-only'></textarea>
                </p>

                <p className='w-750'><center> <h4>DIAGNOSIS</h4></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Primary Diagnosis(es) </span>
                    <textarea id='txtPrimaryDiagnosis' name='txtPrimaryDiagnosis' className='add-only'></textarea>
                </p>
                <p className='w-750'> <span className='eleHeader'>Secondary Diagnosis(es) </span>
                    <textarea id='txtSecondaryDiagnosis' name='txtSecondaryDiagnosis' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Physician/Clinical Psyhologist/Nurse Practitioner, LCSW, LMFT LPC, PA, Alzheimer's Day Program Supervisor </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>Recovery Support Plan</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>ID Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRecoveryName' name='txtRecoveryName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRecoveryIdNumber' name='txtRecoveryIdNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Need Statement(s) from Initial Assessment and ISP </span>
                    <textarea id='txtNeedStatement' name='txtNeedStatement' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Long Term Goal(s) from ISP </span>
                    <textarea id='txtLongTermGoalIsp' name='txtLongTermGoalIsp' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Short Term Goals </span>
                    <textarea id='txtRecoveryShortTerm' name='txtRecoveryShortTerm' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Strengths to Draw Upon (from ISP) </span>
                    <textarea id='txtStrengths' name='txtStrengths' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Barriers which Interfere (from ISP) </span>
                    <textarea id='txtInterfere' name='txtInterfere' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Objectives (what you hope will change for the person as a result of services) </span>
                    <textarea id='txtObjectives' name='txtObjectives' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Strategies (actions by staff, family, other natural supports to assist person in achieving specific objective) </span>
                    <textarea id='txtStrategies' name='txtStrategies' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Person Receiving Services </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Parent / Legal Guardian </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Direct Service Provider </td>
                        <td className='small w-150'> Date </td>
                        <td className='small w-200'> Direct Service Provider </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>Periodic Staffing/Review of the Individual Service Plan</h4></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>ID Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPeriodicName' name='txtPeriodicName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPeriodicIdNumber' name='txtPeriodicIdNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Current Date</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Date of Last ISP/Review</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtCurrentDate' name='txtCurrentDate' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDateOfLastIsp' name='txtDateOfLastIsp' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Time In</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Time Out</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Total</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='time' id='txtPeriodicTimeIn' name='txtPeriodicTimeIn' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtPeriodicTimeOut' name='txtPeriodicTimeOut' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPeriodicTotal' name='txtPeriodicTotal' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Change in diagnosis since last review </span>
                    <textarea id='txtChangeInDiagnosis' name='txtChangeInDiagnosis' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Change in symptoms since last review </span>
                    <textarea id='txtChangeInSymptoms' name='txtChangeInSymptoms' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Change(s) in service activities since last review </span>
                    <textarea id='txtChangeInService' name='txtChangeInService' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Change(s) in household since last review </span>
                    <textarea id='txtChangeInHousehold' name='txtChangeInHousehold' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Change(s) in treatment/Service recommendations since last review </span>
                    <textarea id='txtChangeInTreatment' name='txtChangeInTreatment' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Other significant life change(s) since last review </span>
                    <textarea id='txtOtherSignificant' name='txtOtherSignificant' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Comments/Recommendations </span>
                    <textarea id='txtRecommendations' name='txtRecommendations' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Plan Modification</span>
                    <input type='radio' id='rbPlanModification_Yes' name='rbPlanModification' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPlanModification_No' name='rbPlanModification' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbPlanModification_Rewrite' name='rbPlanModification' className='add-only' value='Rewrite Plan' /> Rewrite Plan
                </p>
                <p className='w-750'> <span className='eleHeader'>if yes, make additions/ modifications to the existing plan</span>
                    <input type='text' id='txtPlanModification' name='txtPlanModification' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Individual Receiving Services </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Staff Signatures/Credentials </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Staff Signatures/Credentials </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Signature of Parent/Legal Guardian (if applicable) </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-600'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-600'> Provider Signature </td>
                        <td className='small w-150'> Date </td>
                    </tr>
                </table>

                <p className='w-750'><center> <h4>Lilly Pad Home Health LLC
                    <small>103 MillCreek Corners Brandon MS 39047</small></h4><h6>Symptom Screening Checklist</h6></center>
                </p>

                <p className='w-750'> <span className='eleHeader'>Client Name:</span>
                    <input type='text' id='txtLillyClientName' name='txtLillyClientName' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Presenting Problems: Describe the problem (s) that brought you here today. Please check any of the symptoms that you are currently experiencing in the past 90 days:</span>
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDepression' name='cbDepression' className='add-only' value='Depression' /> Depression </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFeelingHopeless' name='cbFeelingHopeless' className='add-only' value='Feeling Hopeless' /> Feeling Hopeless </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbExtremeSadness' name='cbExtremeSadness' className='add-only' value='Extreme Sadness' /> Extreme Sadness </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFeelingTearful' name='cbFeelingTearful' className='add-only' value='Feeling Tearful' /> Feeling Tearful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTroubleConcentrating' name='cbTroubleConcentrating' className='add-only' value='Trouble Concentrating' /> Trouble Concentrating </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSleepingHabits' name='cbSleepingHabits' className='add-only' value='Change in sleeping habits' /> Change in sleeping habits &nbsp;
                            <input type='checkbox' id='cbMore' name='cbMore' className='add-only' value='More' /> More &nbsp;
                            <input type='checkbox' id='cbLess' name='cbLess' className='add-only' value='Less' /> Less
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbWeightChanges' name='cbWeightChanges' className='add-only' value='Weight Changes' /> Weight Changes </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbExtremeHappiness' name='cbExtremeHappiness' className='add-only' value='Feeling Extreme Happiness' /> Feeling Extreme Happiness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexualInterest' name='cbSexualInterest' className='add-only' value='Change in Sexual Interest' /> Change in Sexual Interest or Function </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbUnableToRelax' name='cbUnableToRelax' className='add-only' value='Unable to Relax' /> Unable to Relax
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbProblemsGetting' name='cbProblemsGetting' className='add-only' value='Problems Getting Along with Others' /> Problems Getting Along with Others </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLackOfEnjoyment' name='cbLackOfEnjoyment' className='add-only' value='Lack of Enjoyment' /> Lack of Enjoyment of Usual Activities
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFeelingStressed' name='cbFeelingStressed' className='add-only' value='Feeling Stressed' /> Feeling Stressed </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfEsteemProblems' name='cbSelfEsteemProblems' className='add-only' value='Self-Esteem Problems' /> Self-Esteem Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEasilyIrritated' name='cbEasilyIrritated' className='add-only' value='Easily Irritated' /> Easily Irritated </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPerfectionism' name='cbPerfectionism' className='add-only' value='Perfectionism' /> Perfectionism
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFeelingGuilty' name='cbFeelingGuilty' className='add-only' value='Feeling Guilty' /> Feeling Guilty </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbObsessions' name='cbObsessions' className='add-only' value='Obsessions or Compulsion' /> Obsessions or Compulsion
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFeelingNervous' name='cbFeelingNervous' className='add-only' value='Feeling Nervous' /> Feeling Nervous </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFeelingFearful' name='cbFeelingFearful' className='add-only' value='Feeling Fearful' /> Feeling Fearful
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPanic' name='cbPanic' className='add-only' value='Sudden Feeling of Panic' /> Sudden Feeling of Panic </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPain' name='cbPain' className='add-only' value='Physical Complaints of Pain' /> Physical Complaints of Pain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMissingWork' name='cbMissingWork' className='add-only' value='Missing work' /> Missing work or Late for Work </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFallingAsleep' name='cbFallingAsleep' className='add-only' value='Falling Asleep' /> Falling Asleep at Work/School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTruancy' name='cbTruancy' className='add-only' value='Truancy' /> Truancy
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSchoolGradesDropping' name='cbSchoolGradesDropping' className='add-only' value='School Grades Dropping' /> School Grades Dropping </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSuspensions' name='cbSuspensions' className='add-only' value='Suspensions/Detentions' /> Suspensions/Detentions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLeavesClass' name='cbLeavesClass' className='add-only' value='Leaves Class Without Permission' /> Leaves Class Without Permission </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParanoid' name='cbParanoid' className='add-only' value='Paranoid' /> Paranoid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHeadaches' name='cbHeadaches' className='add-only' value='Headaches' /> Headaches </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAggressive' name='cbAggressive' className='add-only' value='Aggressive' /> Aggressive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInstructions' name='cbInstructions' className='add-only' value='Unable to Follow Instructions' /> Unable to Follow Instructions </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCruelToAnimals' name='cbCruelToAnimals' className='add-only' value='Cruel to Animals' /> Cruel to Animals
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDisrespectful' name='cbDisrespectful' className='add-only' value='Disrespectful' /> Disrespectful </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSuicide' name='cbSuicide' className='add-only' value='Thoughts of Suicide' /> Thoughts of Suicide
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLies' name='cbLies' className='add-only' value='Lies' /> Lies </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSteals' name='cbSteals' className='add-only' value='Steals' /> Steals
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTeases' name='cbTeases' className='add-only' value='Teases' /> Teases </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBullies' name='cbBullies' className='add-only' value='Bullies' /> Bullies
                        </td>
                    </tr>
                </table>

            </div >
        </form >
    )
}
